
<svg xmlns="http://www.w3.org/2000/svg"  style="margin: auto; background: none; display: block; shape-rendering: auto;" width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
  <path d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" fill="#0e3a5d" stroke="none" transform="rotate(155.139 50 51)">
    <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51;360 50 51"></animateTransform>
  </path>
</svg>